// The money kinds — ONE list for High Level Finance and High Level
// Operations. Each page used to carry its own copy; they drifted (Operations
// still summed the empty "Projected Expense" type and left "Outsourcing" out
// of Expenses), so both now import this one. No imports here on purpose:
// the node test reads it without a bundler.
//
// id, page-config key (a page may override the work types), default work
// types, label, tile copy, series colour.

export const MONEY_KINDS = Object.freeze([
  { id: 'pinc', cfgKey: 'projectedIncomeTypes', types: ['Projected Income'], label: 'Projected Income', hint: 'Money expected in', colorKey: 'mint' },
  { id: 'deb', cfgKey: 'debtorTypes', types: ['Debtors'], label: 'Debtors', hint: 'Invoices — money in', colorKey: 'teal' },
  { id: 'pexp', cfgKey: 'projectedExpenseTypes', types: ['Projected Expense Budget'], label: 'Projected Expense', hint: 'Money expected out', colorKey: 'rose' },
  { id: 'exp', cfgKey: 'expenseTypes', types: ['Procurement Order', 'Outsourcing'], label: 'Expenses', hint: 'Procurement & outsourcing — money out', colorKey: 'red' },
  { id: 'sal', cfgKey: 'salaryTypes', types: ['Salary Expense', 'Special Projects'], label: 'Salaries & Special Projects', hint: 'Money out', colorKey: 'orange' },
].map((k) => Object.freeze({ ...k, types: Object.freeze(k.types) })));
